<template>
    <v-card>
        <v-card-title class="title">Видалення оцінок за заняття</v-card-title>
        <v-card-text>
            Ви впевнені, що хочете видалити оцінки за заняття № {{topicInfo.classNumber}}, тема "{{topicInfo.nameUk}}"?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    @click.native="$emit('shouldCloseDeleteConfirm')"
                    :disabled="loadingDelete"
            >Ні
            </v-btn>
            <v-btn
                    color="primary"
                    text
                    @click.native="removeItem"
                    :loading="loadingDelete"
                    :disabled="loadingDelete"
            >Так
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import HttpService from "../../../HttpService";

    export default {
        data: () => {
            return {
                loadingDelete: false,
            };
        },
        props: {
            topicInfo: {
                type: Object,
                default: () => {
                    return {
                        topicClass: null,
                    };
                }
            }
        },
        methods: {
            removeItem() {
                this.loadingDelete = true;

                HttpService.getInstance()
                    .delete(`teacher/teacherMarks/${this.topicInfo.topicClass.id}`)
                    .then(resp => {
                        this.loadingDelete = false;

                        this.$emit("removed");
                    });
            }
        }
    }
</script>